import request from '@/utils/request'

/** 移动端：申请本单包装称重填写权限 */
export function createDispatchPackagingAccessRequest(dispatchOrderId, data) {
  return request({
    url: `/api/dispatch-orders/${dispatchOrderId}/packaging-access-requests`,
    method: 'post',
    data: data || {}
  })
}

/** 桌面：包装填写申请列表 status=pending|approved|rejected|all */
export function getDispatchPackagingAccessRequests(params) {
  return request({
    url: '/api/dispatch-orders/packaging-access-requests',
    method: 'get',
    params
  })
}

export function approveDispatchPackagingAccessRequest(accessRequestId, data) {
  return request({
    url: `/api/dispatch-orders/packaging-access-requests/${accessRequestId}/approve`,
    method: 'post',
    data: data || {}
  })
}

export function rejectDispatchPackagingAccessRequest(accessRequestId, data) {
  return request({
    url: `/api/dispatch-orders/packaging-access-requests/${accessRequestId}/reject`,
    method: 'post',
    data: data || {}
  })
}

/** 桌面业务：直接指定或解除包装填写负责人（user_id 为空则解除） */
export function assignDispatchPackagingOperator(dispatchOrderId, data) {
  return request({
    url: `/api/dispatch-orders/${dispatchOrderId}/packaging-operator`,
    method: 'put',
    data: data || {}
  })
}
